import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../util/axiosLib";
import ls from "util/secureStorage";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";

const getToken = () => ls.get(constant.AUTH_TOKEN_KEY).token;

const getHeaders = (token = null) => ({
  authorization: token ?? getToken(),
  "Content-Type": "application/json",
});

const initialState = {
  status: "idle",
  trades: {
    status: "idle",
    type: "pending",
    count: 0,
    data: [],
  },
};

const transformCompletedTradesData = (data) => ({
  ...data,
  adsType: data?.counterParty?.role === "buyer" ? "buying" : "selling",
  fiat:
    data?.originalParty?.role === "seller"
      ? data?.destinationUnit
      : data?.sourceUnit,
  token: data?.originalParty?.role === "seller" ? data?.sourceUnit : data?.coin,
  amount: data?.currencyValue,
  contractState: "closed",
});

const transformTradesWithStatusData = (data) => ({
  fiat: data?.currency,
  token: data?.coin,
  parties: data?.counterParties,
  ...data,
});

export const fetchAllTrades = createAsyncThunk(
  "trade/fetchAllTrades",
  async (pagination) => {
    console.log("PAGINATION", pagination);

    const urls = [
      `/p2p/flexiListing/flexiTrades/completed?limit=${
        pagination.limit / 2
      }&page=${pagination.page}&sortBy=createdAt:desc`,
      `/p2p/flexiListing/flexiTrades/own?limit=${pagination.limit / 2}&page=${
        pagination.page
      }&sortBy=createdAt:desc`,
    ];

    const toRun = [];
    urls.forEach((url) => {
      toRun.push(
        get(wrapBaseApi(`${url}`), getHeaders())
      );
    });

    const res = await Promise.all(toRun);

    const result = res.map((r) => r?.data?.data);

    console.log("ALL TRADES", result);
    return result;
  }
);

export const fetchTradesByStatus = createAsyncThunk(
  "trade/fetchTradesByStatus",
  async (input) => {
    const res = await get(
      wrapBaseApi(`/p2p/flexiListing/flexiTrades/own?status=${input.type}&limit=${input.limit}&page=${input.page}&sortBy=createdAt:desc`),
      getHeaders()
    );

    console.log("TRADES BY STATUS", res.data);
    return res.data?.data;
  }
);

export const fetchCompletedTrades = createAsyncThunk(
  "trade/fetchCompletedTrades",
  async (pagination) => {
    const res = await get(
      wrapBaseApi(`/p2p/flexiListing/flexiTrades/completed?limit=${pagination.limit}&page=${pagination.page}&sortBy=createdAt:desc`),
      getHeaders()
    );

    // console.log("COMPLETED TRADES", res.data);
    return res.data?.data;
  }
);

const tradeSlice = createSlice({
  name: "trade",
  initialState,
  reducers: {
    updateTradeType: (state, action) => {
      state.trades.type = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllTrades.fulfilled, (state, { payload }) => {
      state.trades.status = "success";
      state.trades.count =
        payload[0]?.totalCount &&
        payload[1]?.totalCount &&
        Number(payload[0]?.totalCount + payload[1]?.totalCount);

      payload[0]?.trades &&
        payload[1]?.trades &&
        (state.trades.data = [
          ...payload[0]?.trades?.map(transformCompletedTradesData),
          ...payload[1]?.trades?.map(transformTradesWithStatusData),
        ].filter(Boolean));
    });
    builder.addCase(fetchAllTrades.pending, (state, action) => {
      state.trades.status = "fetching";
    });
    builder.addCase(fetchAllTrades.rejected, (state, action) => {
      state.trades.status = "error";
    });

    // Trades by status
    builder.addCase(fetchTradesByStatus.fulfilled, (state, { payload }) => {
      state.trades.status = "success";
      state.trades.count = payload.totalCount;
      state.trades.data = payload.trades?.map(transformTradesWithStatusData);
    });
    builder.addCase(fetchTradesByStatus.pending, (state, action) => {
      state.trades.status = "fetching";
    });
    builder.addCase(fetchTradesByStatus.rejected, (state, action) => {
      state.trades.status = "error";
    });

    // Completed Trades
    builder.addCase(fetchCompletedTrades.fulfilled, (state, { payload }) => {
      state.trades.status = "success";
      state.trades.count = payload.totalCount;
      state.trades.data = payload.trades?.map(transformCompletedTradesData);
    });
    builder.addCase(fetchCompletedTrades.pending, (state, action) => {
      state.trades.status = "fetching";
    });
    builder.addCase(fetchCompletedTrades.rejected, (state, action) => {
      state.trades.status = "error";
    });
  },
});

export const selectTrade = (state) => state.trade;

export const { actions, reducer: TradeReducer } = tradeSlice;

export const { updateTradeType } = actions;
